// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-footer {
  position: absolute;
  height: 50px;
  bottom: 0;
  right: 0;
}

.case-save-button {
  display: flex;
  justify-content: end;
  padding-top: 6em;
  padding-bottom: 2em;
}

.case-footer-relative {
  position: relative !important;
  display: flex;
  justify-content: flex-end;
  padding-right: 1rem;
}

.attachment-size-info {
  color: #dc3545;
  font-size: 0.75rem;
  margin-top: 2px;
  margin-left: 5px;
}

.cases-guard-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 12%;
  gap: 20px;
}

.cases-guard-icon {
  opacity: 0.4;
  font-size: 200px;
}

.cases-guard-text {
  font-size: 30px;
  font-weight: 500;
  letter-spacing: 0.2px;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/edozvola/cases/cases.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AACF","sourcesContent":[".case-footer {\n  position: absolute;\n  height: 50px;\n  bottom: 0;\n  right: 0;\n}\n\n.case-save-button {\n  display: flex;\n  justify-content: end;\n  padding-top: 6em;\n  padding-bottom: 2em;\n}\n\n.case-footer-relative {\n  position: relative !important;\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 1rem;\n}\n\n.attachment-size-info {\n  color: #dc3545;\n  font-size: 0.75rem;\n  margin-top: 2px;\n  margin-left: 5px;\n}\n\n.cases-guard-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 12%;\n  gap: 20px;\n}\n\n.cases-guard-icon {\n  opacity: 0.4;\n  font-size: 200px;\n}\n\n.cases-guard-text {\n  font-size: 30px;\n  font-weight: 500;\n  letter-spacing: 0.2px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
